import React from "react";

import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Avatar from "@mui/material/Avatar";
import { useTheme } from "@mui/material/styles";

import CloseCircleOutline from "mdi-material-ui/CloseCircleOutline";

const ImageModal = (props) => {
  const { open, handleClose, imageUrl } = props;
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      scroll="body"
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          paddingRight: 5,
          paddingTop: 5,
          cursor: "pointer",
        }}
        onClick={handleClose}
      >
        <CloseCircleOutline
          fontSize="small"
          sx={{ stroke: "#ffffff", strokeWidth: 1 }}
          style={{
            height: 20,
            width: 20,
            color: theme.palette.secondary.main,
          }}
        />
      </Box>
      <Box
        sx={{
          padding: 5,
          display: "flex",
          justifyContent: "center",
          // width: 600,
          height: 480,
        }}
      >
        <Avatar
          alt="Img"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
          src={imageUrl}
          variant="square"
        />
      </Box>
    </Dialog>
  );
};

export default ImageModal;
